(function() {
    angular
        .module("feedbackModule")
        .controller("FeedbackDetailsController", FeedbackDetailsController)

    FeedbackDetailsController.$inject = [
        "$rootScope",
        "$scope",
        "$stateParams",
        "feedbackService",
        "userMessagingService"
    ]

    function FeedbackDetailsController(
        $rootScope,
        $scope,
        $stateParams,
        feedbackService,
        userMessagingService
    ){
        "use strict"

        /**
            $rootScope variables
         **/
        $rootScope.title = "Feedback Details | WANCO"

        /**
            $scope variables
         **/
        $scope.feedback = []
        $scope.editFeedbackFormData = {}

        $scope.statusOptions = [
            {id:"1", label: "Pending"},
            {id:"2", label: "In Review"},
            {id:"3", label: "In Progress"},
            {id:"4", label: "Closed"}
        ]

        /**
            Get single feedback
         **/
        feedbackService.getSingleFeedback($stateParams.feedback_id).then(function(data) {
            $scope.feedback = data
            $scope.editFeedbackFormData = {
                status: $scope.feedback.status || undefined,
                notes: $scope.feedback.notes || ""
            }
        })

        /**
            Edit feedback
         **/
        $scope.editFeedback = function() {
            $scope.submitted = true
            if ($scope.editFeedbackForm.$valid) {
                $scope.editFeedbackFormData = {
                    feedback: $scope.editFeedbackFormData
                }
                feedbackService.editFeedback(
                    $stateParams.feedback_id,
                    angular.fromJson($scope.editFeedbackFormData),
                    function() {
                        //Success
                        userMessagingService.success("Feedback Successfully Edited")
                    },
                    function(error) {
                        //Failure
                        userMessagingService.error(error)
                    }
                )
            }
        }
    }
})()
